// import { Component, OnInit } from '@angular/core';
// import { aboutConst } from '../../constants';

// @Component({
//     selector: 'app-about',
//     templateUrl: './about.component.html',
//     styleUrls: ['./about.component.scss'],
// })
// export class AboutComponent implements OnInit {
//     formValues = aboutConst;

//     constructor() {}

//     ngOnInit(): void {}
// }


import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';

import { aboutConst } from '../../constants';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
})
export class AboutComponent
    implements OnInit, AfterViewInit, OnDestroy {

    // =====================================================
    // EXISTING ABOUT CONTENT
    // =====================================================

    formValues = aboutConst;


    // =====================================================
    // VIDEO
    // =====================================================

    videoPlaying = false;

    @ViewChild('aboutVideo')
    aboutVideo?: ElementRef<HTMLVideoElement>;


    // =====================================================
    // SCROLL REVEAL
    // =====================================================

    private observer?: IntersectionObserver;


    // =====================================================
    // CONSTRUCTOR
    // =====================================================

    constructor(
        private hostElement: ElementRef<HTMLElement>
    ) {}


    // =====================================================
    // ANGULAR LIFECYCLE
    // =====================================================

    ngOnInit(): void {
        // No initialization required
    }


    ngAfterViewInit(): void {

        // Initialize client-style reveal animations
        this.initScrollReveal();

    }


    ngOnDestroy(): void {

        // Stop observing when leaving About page
        this.observer?.disconnect();

    }


    // =====================================================
    // VIDEO
    // =====================================================

    playVideo(): void {

        const video =
            this.aboutVideo?.nativeElement;


        // Video element not available
        if (!video) {
            return;
        }


        // =================================================
        // PLAY
        // =================================================

        if (video.paused) {

            video.play()
                .then(() => {

                    this.videoPlaying = true;

                })
                .catch(() => {

                    this.videoPlaying = false;

                });

        }


        // =================================================
        // PAUSE
        // =================================================

        else {

            video.pause();

            this.videoPlaying = false;

        }

    }


    // =====================================================
    // SCROLL REVEAL
    // =====================================================
    //
    // Elements containing:
    //
    //     data-reveal
    //
    // will initially be hidden.
    //
    // When they enter the viewport:
    //
    //     reveal-hidden
    //             ↓
    //     reveal-visible
    //
    // Each element is observed only once.
    //
    // Therefore:
    //
    // Scroll down -> animation appears
    // Scroll up   -> remains visible
    //
    // =====================================================

    private initScrollReveal(): void {

        // =================================================
        // BROWSER SUPPORT CHECK
        // =================================================

        const host =
            this.hostElement.nativeElement;

        const elements =
            Array.from(
                host.querySelectorAll<HTMLElement>(
                    '[data-reveal]'
                )
            );

        if (!elements.length) {
            return;
        }

        // Browser support check
        if (
            typeof window === 'undefined' ||
            typeof IntersectionObserver === 'undefined'
        ) {
            elements.forEach((el) => {
                el.classList.add('reveal-visible');
            });
            return;
        }


        // =================================================
        // INITIAL STATE
        // =================================================

        elements.forEach((element) => {

            // Make sure the element starts hidden
            element.classList.remove(
                'reveal-visible'
            );

            element.classList.add(
                'reveal-hidden'
            );


            // =================================================
            // READ OPTIONAL ANIMATION DELAY
            // =================================================

            const delay =
                element.getAttribute(
                    'data-reveal-delay'
                );


            if (!delay) {
                return;
            }


            const delayNumber =
                parseInt(delay, 10);


            if (Number.isNaN(delayNumber)) {
                return;
            }


            element.style.setProperty(
                '--reveal-delay',
                `${delayNumber}ms`
            );

        });


        // =================================================
        // CREATE INTERSECTION OBSERVER
        // =================================================

        this.observer =
            new IntersectionObserver(

                (entries) => {

                    entries.forEach((entry) => {

                        // Element has not entered viewport
                        if (!entry.isIntersecting) {
                            return;
                        }


                        const element =
                            entry.target as HTMLElement;


                        // =================================================
                        // REVEAL ELEMENT
                        // =================================================

                        element.classList.remove(
                            'reveal-hidden'
                        );

                        element.classList.add(
                            'reveal-visible'
                        );


                        // =================================================
                        // STOP OBSERVING
                        // =================================================
                        //
                        // Important:
                        // Animation happens only once.
                        //
                        // When the user scrolls back up,
                        // the element remains visible.
                        //
                        // =================================================

                        this.observer?.unobserve(
                            element
                        );

                    });

                },

                {
                    threshold: 0.12,

                    rootMargin:
                        '0px 0px -40px 0px'
                }

            );


        // =================================================
        // START OBSERVING
        // =================================================

        elements.forEach((element) => {

            this.observer?.observe(
                element
            );

        });

    }

}